import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ContractRequest } from 'ng2-app/services/contract-requests/contract-request.model';
import { ContractRequestService } from 'ng2-app/services/contract-requests/contract-request.service';
import { Deal } from 'ng2-app/models/dto/deal.model';
import { EventBusService } from 'ng2-app/modules/shared/services/event-bus.service';
import { DecimalPipe } from '@angular/common';

interface ContractRequestItem {
  label: string;
  value?: string|number|null;
}

@Component({
  selector: 'contract-request-details',
  templateUrl: 'contract-request-details.component.html',
  styleUrls: ['contract-request-details.component.scss'],
  standalone: false
})
export class ContractRequestDetailsComponent implements OnChanges {

  @Input() contract_request: ContractRequest;
  @Input() deal: Deal;
  @Input() canEditContractRequests: boolean;
  @Input() sending: boolean = false;
  @Output() newItemEvent = new EventEmitter<void>();

  detailItems: ContractRequestItem[] = [];

  paymentFrequencyOptionNames = {
    biWeekly: 'Every Two Weeks',
    daily: 'Daily',
    monthly: 'Monthly',
    weekly: 'Weekly',
  };

  constructor(
    private eventBusService: EventBusService,
    private contractRequestService: ContractRequestService,
    private decimalPipe: DecimalPipe,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['contract_request'] || changes['deal']) {
      this.generateDetailItems();
    }
  }

  edit() {
    this.newItemEvent.emit();
  }

  private generateDetailItems() {
    const productType = this.deal?.loan_product?.category?.type || '';
    const isLOC = productType === 'loc';

    this.detailItems = [
      {
        label: 'Lender',
        value: this.deal?.loan_product_lender.name || '',
      },
      {
        label: 'Product Type',
        value: this.deal?.loan_product.category.shortName || ''
      },
      {
        label: isLOC ? 'Initial Draw Amount' : 'Loan Amount',
        value: isLOC ? this.contract_request.terms?.initialDrawAmount : this.contract_request.terms?.amount,
      },
      ...(isLOC ? [{
        label: 'Credit Limit',
        value: this.contract_request.terms?.creditLimit,
      }] : []),
      ...(productType === 'term' && this.contract_request.terms?.originationFeeAmount ? [{
        label: 'Origination Fee',
        value: this.contract_request.terms.originationFeeAmount,
      }] : []),
      {
        label: 'Term',
        value: `${this.contract_request.terms?.term} ${this.contract_request.terms?.termType}`,
      },
      ...(productType === 'ach' || this.contract_request.terms?.points) ? [{
        label: 'Points',
        value: this.decimalPipe.transform(this.contract_request.terms?.points),
      }] : [],
      ...(productType === 'ach' ? [{
        label: 'Factor Rate',
        value: this.decimalPipe.transform(this.contract_request.terms?.factorRate),
      }] : []),
      {
        label: 'Payment Frequency',
        value: this.paymentFrequencyOptionNames[this.contract_request.terms?.paymentFrequency || ''],
      },
      {
        label: 'Business Owner Email(s)',
        value: this.contract_request.signers?.map(signer => signer.email).join(', '),
      },
      {
        label: 'Best Number for Funding Call',
        value: this.contract_request?.fundingCallPhone,
      }
    ];
  }
}
